export enum LivenessEnum {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING'
}
